export default __webpack_public_path__ + "015e7809f8c7b8776bb7c88f4f2f1c13.png";